module.exports = __webpack_public_path__ + "img/icon_features_pause0_hover.77365ca1.svg";